import client from '../../../helpers/client';
import cognito from '../../../helpers/cognito';

export const getListKarmaByDao = (params) => {
  return async () => {
    const { daoId, chainId, page, limit, email, startDate, endDate } = params;
    const queryParams = new URLSearchParams({
      territory: daoId,
      page,
      limit,
      email: email || '',
      startDate: startDate || '',
      endDate: endDate || ''
    }).toString();

    return client
      .api(`/karma/get-total-by-activity?${queryParams}`, 'get', {
        headers: await cognito.getHeaderAuthorization()
      })
      .then(({ data: response }) => {
        return response;
      })
      .catch((err) => {
        return null;
      });
  };
};


export const getListCreditByDao = (params) => {
  return async () => {
    const { daoId, page, limit, email, startDate, endDate } = params;
    const queryParams = new URLSearchParams({
      territory: daoId,
      page,
      limit,
      email: email || '',
      startDate: startDate || '',
      endDate: endDate || ''
    }).toString();

    return client
      .api(`/credit/get-total-by-activity?${queryParams}`, 'get', {
        headers: await cognito.getHeaderAuthorization()
      })
      .then(({ data: response }) => {
        return response;
      })
      .catch((err) => {
        return null;
      });
  };
};

export const getHistoryWalletByDao = (params) => {
  return async () => {
    const { daoId } = params;
    const queryParams = new URLSearchParams({
      territory: daoId,
      notInReview: true
    }).toString();

    return client
      .api(`/k-wallet/get-kwallet?${queryParams}`, 'get', {
        headers: await cognito.getHeaderAuthorization()
      })
      .then(({ data: response }) => {
        return response;
      })
      .catch((err) => {
        return null;
      });
  };
};

export const getKarmaCreditActivityByEmail = (params) => {

  return async () => {
    const { daoId, email } = params;
    const queryParams = new URLSearchParams({
      territory: daoId,
      email: email
    }).toString();

    return client
      .api(`/user/karma-credit/activity?${queryParams}`, 'get', {
        headers: await cognito.getHeaderAuthorization()
      })
      .then(({ data: response }) => {
        return response;
      })
      .catch((err) => {
        return null;
      });
  };
};